/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OperatorType = {
    Admin: 'Admin',
    Member: 'Member'
} as const;
export type OperatorType = typeof OperatorType[keyof typeof OperatorType];

